import React, { useEffect, useState } from 'react';

import classNames from 'classnames';

import { sinatraOrigin } from '../../../config';

export const withPingResults = BaseComponent => (props) => {
  const [pingResult, setPingResult] = useState('nothing');

  useEffect(() => {
    fetch(`${sinatraOrigin}/ping`)
      .then(response => response.json())
      .then(response => setPingResult(response.result));
  }, []);

  return (
    <BaseComponent {...props} pingResult={pingResult}/>
  );
}

export const withTempData = BaseComponent => (props) => {
  const [tempData, setTempData] = useState(null);

  useEffect(() => {
    fetch(
      `${sinatraOrigin}/v1/metrics/api/v1/query_range?query=histogram_quantile(0.99%2C%20sum(rate(inference_latency_histogram_ns_bucket%5B15s%5D))%20by%20(le))%20*%201000&start=1620156405&end=1620156705&step=15`,
    )
      .then(response => response.json())
      .then(response => setTempData(response));
  }, []);

  return (
    <BaseComponent {...props} tempData={tempData} />
  )
};

export const Status = ({ pingResult, tempData }) => (
  <div className="m-8">
    <div>Status</div>

    <div className="flex justify-start items-center">
      <div
        className={classNames('w-4 h-4 rounded-full mr-4', {
          'bg-green-500': pingResult === 'pong',
          'bg-red-500': pingResult !== 'pong',
        })}
      />
      <div>Ping</div>
    </div>

    <div className="flex justify-start items-center">
      <div
        className={classNames('w-4 h-4 rounded-full mr-4', {
          'bg-green-500': !!tempData,
          'bg-red-500': !tempData,
        })}
      />
      <code>{tempData ? JSON.stringify(tempData) : 'Nothing yet'}</code>
    </div>
  </div>
);
export default withTempData(withPingResults(Status));
